import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface BulkActionsBarProps {
	selectedDemoCount: number;
	children: React.ReactNode;
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({ selectedDemoCount, children }) => {
	return (
		<div className={css(styleSheet.bulkActionsContainer)}>
			<div className={css(styleSheet.bulkActionsContent)}>
				<span className={css(styleSheet.selectedCount)}>
					{selectedDemoCount > 0
						? `${selectedDemoCount} demo${selectedDemoCount !== 1 ? 's' : ''} selected`
						: 'No demos selected'}
				</span>
				<div className={css(styleSheet.bulkActions)}>{children}</div>
			</div>
		</div>
	);
};
